import { render, staticRenderFns } from "./OwalRadioInput.vue?vue&type=template&id=0f819c67&scoped=true"
import script from "./OwalRadioInput.vue?vue&type=script&lang=js"
export * from "./OwalRadioInput.vue?vue&type=script&lang=js"
import style0 from "./OwalRadioInput.vue?vue&type=style&index=0&id=0f819c67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f819c67",
  null
  
)

export default component.exports